<div class="participant"
     [class.is-screen]="isScreen(source)"
>
  <div class="participant__col">
          <span class="participant__avatar">
            <span class="participant__pic avatar"
                  [attr.alt]="source.video.name"
            ></span>
            <span class="participant__char">{{ (source.video.name) | firstWord }}</span>
          </span>
  </div>
  <div class="participant__col participant__col--right"
       (click)="raiseVideoToTop(source.video.id)"
  >
    <div class="participant__text participant__text--user"
         [ngClass]="{
                'is-talking': ((talking$(source.video.id) | async) === true) && userMedia.audio
              }"
    >
      {{ source.video.name }}
    </div>
  </div>
  <div class="participant__states">
    <div [style.display]="isScreen(source) ? '' : 'none'"
         class="control-button-outer share-on">
      <stusan-control-button>
        <stusan-icon icon="menu-share-on"
                     style="width: 16px; height: 16px;"></stusan-icon>
      </stusan-control-button>
    </div>
    <div [style.display]="!userMedia.video && !isScreen(source) ? '' : 'none'"
         class="control-button-outer cam-off">
      <stusan-control-button>
        <stusan-icon icon="cam-off"
                     style="width: 16px; height: 16px;"
                     [style.fill]="'#fff'"></stusan-icon>
      </stusan-control-button>
    </div>
    <div [style.display]="userMedia.video && !isScreen(source) ? '' : 'none'"
         class="control-button-outer cam-on">
      <stusan-control-button>
        <stusan-icon icon="menu-cam-on"
                     style="width: 16px; height: 16px;"></stusan-icon>
      </stusan-control-button>
    </div>
    <div [style.display]="!userMedia.audio ? '' : 'none'"
         class="control-button-outer mic-off">
      <stusan-control-button>
        <stusan-icon icon="mic-off"
                     style="width: 16px; height: 16px;"
                     [style.fill]="'#fff'"></stusan-icon>
      </stusan-control-button>
    </div>
    <div [style.display]="((talking$(source.video.id) | async) === false) && userMedia.audio ? '' : 'none'"
         class="control-button-outer mic-on">
      <stusan-control-button>
        <stusan-icon icon="menu-mic-on"
                     style="width: 16px; height: 16px;"></stusan-icon>
      </stusan-control-button>
    </div>
    <div [style.display]="((talking$(source.video.id) | async) === true) && userMedia.audio ? '' : 'none'"
         class="control-button-outer mic-off activity">
      <stusan-control-button>
        <thevatra-equalizer [color]="'#0299DB'" [size]="'16px'"></thevatra-equalizer>
      </stusan-control-button>
    </div>
  </div>
</div>
